import Theme from "@/components/Theme";
import Hero from "@/organisms/Hero";
import FeatureSectionTwocol from "@/organisms/FeatureSectionTwocol";
import Discover from "@/organisms/Discover";
import Trustpilot from "@/organisms/Trustpilot";
import AudioLayout from "@/organisms/AudioLayout";
import ServicesSectionTwoCol from "@/components/organisms/ServicesSectionTwoCol";
import Faq from "@/components/organisms/FaqSection";
import RegistrationForm from "@/components/molecules/RegistrationForm";
import * as AnsweringServices from "@/data/answering-services/answering-services";
import Slider from "@/components/organisms/Slider";
export async function getStaticProps() {
  const data = {
    marketing: AnsweringServices.marketing,
    content: AnsweringServices.content,
  };

  return {
    props: {
      data,
      pagename: "answering-services",
    },
  };
}

export default function Page({ data, pagename }) {
  const seoData = data?.marketing;
  const pagedata = data?.content;

  const {
    hero,
    audioLayout,
    featureSectionTwocol1,
    servicesSectionTwoCol,
    trustPilot,
    slider,
    miniRegister,
    faq,
    discover,
  } = pagedata;

  const heroComponent = hero && (
    <Hero
      heroTitle={hero.title}
      heroContent={hero.content}
      heroImgData={hero.heroImgData}
      hasPricingCta={hero.hasPricingCta}
      hasTrustpilot={hero.hasTrustpilot}
    />
  );

  return (
    <Theme mainClassName="main" hero={heroComponent} seo={seoData}>
      <AudioLayout
        title={audioLayout.title}
        image={audioLayout.image}
        isLPvariant
        isV2AnsweringService
        className={audioLayout.className}
      />
      <FeatureSectionTwocol
        title={featureSectionTwocol1.title}
        image={featureSectionTwocol1.image}
        bgColor={featureSectionTwocol1.bgColor}
        content={featureSectionTwocol1.content}
        isImageOnLeft={featureSectionTwocol1.isImageOnLeft}
        hasTitleDot={featureSectionTwocol1.hasTitleDot}
        ctaData={featureSectionTwocol1.ctaData}
      />
      <ServicesSectionTwoCol
        bgColor={servicesSectionTwoCol.bgColor}
        label={servicesSectionTwoCol.label}
        title={servicesSectionTwoCol.title}
        subText={servicesSectionTwoCol.subText}
        listData={servicesSectionTwoCol.listData}
        image={servicesSectionTwoCol.image}
        contentData={servicesSectionTwoCol.contentData}
      />
      <Trustpilot
        title={trustPilot.title}
        variant={trustPilot.variant}
        className={trustPilot.className}
      />
      <Slider
        data={slider.data}
        variant={slider.variant}
        title={slider.title}
        subTitle={slider.subTitle}
      />
      <RegistrationForm
        title={miniRegister.title}
        content={miniRegister.content}
        hasBusinessNameField={false}
        variant="mini"
        formUniqueName={`page-${pagename}-mini`}
      />
      <Faq data={faq.faqData} />
      <Discover
        bgColor={discover.bgColor}
        title={discover.title}
        color={discover.color}
        cta={discover.cta}
        href={discover.href}
      />
    </Theme>
  );
}
